import { CardTypeEnum } from '../enums/card-type.enum';

export function CvvMask(isAmex: boolean) {
  if (isAmex) {
    return CardTypeEnum.AMEX.cvvMask;
  } else {
    return CardTypeEnum.GENERIC.cvvMask;
  }
}
